import React, { FC, useEffect, useState } from "react";
import { WiegandCard } from "./WiegandCard";
import CommsCard from "./CommsCard";
import { HIK_VISION_SETTINGS } from "../../constants/preset-constants";
import { HIK_WIEGAND_FIELDS, HIK_COMMS_FIELDS, HIK_AUTH_FIELDS, HIK_THERMAL_FIELDS } from "../../constants/biometric-fields-names";
import AuthenticationCard from "./AuthenticationCard";
import ThermalCard from "./ThermalCard";


interface HikVisionPresetProps {
    presetId?: string;
    presetCardType: string
}

export const HikVisionPresets: FC<HikVisionPresetProps> = ({ presetId = '', presetCardType }) => {
    const [content, setContent] = useState<any>([]);

    useEffect(() => {
        setTabContent();
    }, [presetCardType])

    const setTabContent = () => {
        switch (presetCardType) {
            case HIK_VISION_SETTINGS.COMMS:
                {
                    setContent([<CommsCard presetId={presetId} commsFields={HIK_COMMS_FIELDS} />]);
                    break;
                }
            case HIK_VISION_SETTINGS.WIEGAND:
                {
                    setContent([<WiegandCard presetId={presetId} wiegandFields={HIK_WIEGAND_FIELDS}/>]);
                    break;
                }
            case HIK_VISION_SETTINGS.AUTHENTICATION_SETTINGS:
                {
                    setContent([<AuthenticationCard presetId={presetId} authenticationFields={HIK_AUTH_FIELDS}/>]);
                    break;
                }
            case HIK_VISION_SETTINGS.THERMAL_SETTINGS:
                {
                    setContent([<ThermalCard presetId={presetId} thermalFields={HIK_THERMAL_FIELDS}/>]);
                    break;
                }
            
            default: { };
        }
    }

    return (content);
};
